import type { LedgerConnectionResponse } from '@mynt/backoffice-api-spec/ledger-platform'
import type { LedgerConnection } from './api'

export const mapLedgerConnectionResponse = (response: LedgerConnectionResponse): LedgerConnection => ({
  systemName: response.systemName,
})
